export const toDocumentAssignItem = (item, action) => ({
	id: item.id,
	requirementId: item.requirementId || item.id,
	title: item.title,
	action,
})

export const buildDocumentAssignLists = groups => {
	const flat = (groups || []).flatMap(group => group.items || [])
	const missingItems = flat
		.filter(item => item.counselorStatus !== 'success')
		.map(item => toDocumentAssignItem(item, 'upload_new'))
	const uploadedItems = flat
		.filter(item => item.counselorStatus === 'success')
		.map(item => toDocumentAssignItem(item, 'reupload'))
	return { missingItems, uploadedItems }
}

export const buildAssignAllDocumentsPreset = groups => {
	const { missingItems, uploadedItems } = buildDocumentAssignLists(groups)
	return {
		locked: false,
		missingItems,
		uploadedItems,
	}
}
